import debug from 'debug';
// Using UMD version instead of ES6, @see https://github.com/nolimits4web/Swiper/issues/2237 @4.5.1
// import Swiper from 'swiper/dist/js/swiper.js';
import Swiper from 'swiper/bundle';

import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';
import BrowserSpecific from 'Global/Shared/Components/browser-specific/browser-specific';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import Utils from 'Global/Shared/Components/Utils/Utils';
import Sitecore from 'Global/Shared/Components/Sitecore/Sitecore';
import CloudApi from 'Minetilbud/Shared/Components/CloudApi/Adverts';
import Templates from './Templates';

import tilbageRenSvg from 'Minetilbud/Shared/Icons/tilbage_ren.svg';
import fremRenSvg from 'Minetilbud/Shared/Icons/frem_ren.svg';

const log = debug('InspirationTextFeed');
const debounce = new Debounce().debounce;
const templates = new Templates();
const utils = new Utils();

class InspirationTextFeed extends BaseComponent {
	constructor(element) {
		super(element)

		this.scrollEvent = this.scrollHandler.bind(this);
		this.scrollHandler = debounce(this.scrollHandler, 250);

		this.initialize();
	}

	customLinkButton() {
		if (!this.dom.linkButton) return;

		const utils = new Utils();

		if (!utils.IsNullOrWhiteSpace(this.settings.buttonTextColor)) {
			this.dom.linkButton.style.color = this.settings.buttonTextColor;
		}

		if (!utils.IsNullOrWhiteSpace(this.settings.buttonBackgroundColor)) {
			this.dom.linkButton.style.backgroundColor = this.settings.buttonBackgroundColor;
		}
	}

	eventListeners() {
		document.addEventListener('scroll', this.scrollEvent, true);
	}

	async getProducts() {
		if (this.products !== undefined) return this.products;

		if (this.isFollowingRuns === true) return [];
		this.isFollowingRuns = true;

		try {
			const cloudapi = new CloudApi();
			const response = await cloudapi.PickByCategories(this.settings.categories, this.settings.customers, this.settings.maxCountPerCategory);

			log('getProducts()', response);
			if (response.status !== 200) {
				this.products = [];
				return [];
			}

			this.products = response.json();

			return this.products;
		} catch (error) {
			log('getProducts() - ERROR', error);
		}
	}

	/**
	 * @returns {Object} settings
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	initialize() {
		if (this.getSettings() === null) return;

		this.initDomCache();
		this.customLinkButton();
		this.eventListeners();

		if (BrowserSpecific.isIE11()) {
			this.setup();
			return;
		}

		if (this.isInView() === false) return;

		this.setup();
	}

	isInView() {
		if (Sitecore.isEdit()) return true;

		const elementRect = this.element.getBoundingClientRect();

		if ((elementRect.top > 0 || elementRect.bottom > 0) && elementRect.top < window.innerHeight) {
			return true;
		};

		return false;
	}

	async render(products) {
		if (products.length === 0) return;
		log('render() - products', products);

		await templates.initDictionary();

		products.map(product => {
			this.dom.products.insertAdjacentHTML('beforeend', templates.product({
				carousel: products.length > 3,
				product
			}));
		});

		this.element.classList.add('is-visible');

		if (products.length > 3) {
			const buttonNext = this.element.querySelector(`[data-js="HeroBannerCarouselButtonNext${this.settings.id}"]`);
			const buttonPrev = this.element.querySelector(`[data-js="HeroBannerCarouselButtonPrev${this.settings.id}"]`);

			this.dom.products.classList.remove('o-inspiration-text-feed__adverts');
			this.dom.products.classList.add('swiper-wrapper');

			buttonNext.classList.add(`o-inspiration-text-feed__button-next`);
			buttonNext.insertAdjacentHTML('beforeend', fremRenSvg);
			buttonPrev.classList.add(`o-inspiration-text-feed__button-prev`);
			buttonPrev.insertAdjacentHTML('beforeend', tilbageRenSvg);

			this.swipe();
		}
	}

	scrollHandler() {
		if (this.element.classList.contains('is-in-view')) return;
		if (this.isInView() === false) return;
		this.setup();
	}

	async setup() {
		const products = await this.getProducts();
		if (products.length === 0) return;

		this.element.classList.add('has-products');

		if (this.isInView() === false && BrowserSpecific.isIE11() === false) return;
		if (this.element.classList.contains('is-in-view')) return;
		this.element.classList.add('is-in-view');

		this.render(products);
	}

	swipe() {
		let options = {
			slidesPerView: 3,
			spaceBetween: 0,
			slidesPerGroup: 3,
			speed: this.settings.speed,
			loop: this.settings.loop,
			loopFillGroupWithBlank: true,
			pagination: {
				el: `[data-js="InspirationTextFeedPagination${this.settings.id}"]`,
				clickable: true,
				bulletClass: 'o-inspiration-text-feed__bullet',
				bulletActiveClass: 'o-inspiration-text-feed__bullet--active'
			},
			navigation: {
				nextEl: `[data-js="HeroBannerCarouselButtonNext${this.settings.id}"]`,
				prevEl: `[data-js="HeroBannerCarouselButtonPrev${this.settings.id}"]`
			}
		}

		if (this.settings.autoStart) {
			const autoStart = {
				autoplay: {
					delay: this.settings.delay
				}
			}
			options = utils.Extend(options, autoStart);
		}

		log('swipe() - options', options);

		const swiper = new Swiper(`[data-js="InspirationTextFeedSwiper${this.settings.id}"]`, options);
	}
}

export default InspirationTextFeed;
